import clsx from 'clsx';
import styles from './index.module.scss';
import { externalReportsService } from 'store/external-reports';

export interface MetabaseAppDashboardProps {
  className?: string;
}

function MetabaseAppDashboard(props: MetabaseAppDashboardProps) {
  const dashboardUrlRequest = externalReportsService.useGetDashboardUrlQuery({
    dashboardId: 12,
    params: {},
  });

  if (!dashboardUrlRequest.data) {
    return null;
  }

  return (
    <div className={clsx(styles.root, props.className)}>
      <iframe
        className={styles.iframe}
        src={dashboardUrlRequest.data.dashboardUrl}
        width="800"
        height="600"
      ></iframe>
    </div>
  );
}

export default MetabaseAppDashboard;
